<div class="pollForm">
    <form [formGroup]="formGroup">
        <div class="flex-col">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Poll text</mat-label>
                <textarea formControlName="text"
                          matInput
                          maxlength="400" rows="3"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100"
                            color="accent">
                <mat-label>Poll description</mat-label>
                <textarea formControlName="description"
                          matInput
                          maxlength="400" rows="4"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="noBottomPadding" color="accent">
                <mat-label>Finish date</mat-label>
                <input [matDatepicker]="picker" formControlName="end_at" matInput>
                <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-checkbox (change)="likertScale($event)" formControlName="scale">Matrix poll</mat-checkbox>
            <small class="pl-10">Display the options horizontally instead of vertically</small>
            <mat-checkbox *ngIf="isScale" formControlName="matrix_exclusive">Make the
                column options exclusive
            </mat-checkbox>
            <mat-form-field *ngIf="isScale" appearance="outline" class="mt-10" color="accent">
                <mat-label>Number of scale options</mat-label>
                <mat-select [(ngModel)]="scaleAmount" (ngModelChange)="scaleUpdate()" ngDefaultControl
                            [disabled]="editMode" [ngModelOptions]="{standalone: true}">
                    <mat-option *ngFor="let number of scaleNumbers" [value]="number">{{ number }}</mat-option>
                </mat-select>
                <mat-hint>Options will be a scale from 1-{{ scaleAmount }}.
                    <ng-container *ngIf="isMatrixExclusive">
                        Scale options must be greater than or equal to the amount of
                        questions when column options exclusive is selected.
                    </ng-container>
                </mat-hint>
            </mat-form-field>
            <mat-checkbox [hidden]="!isScale" formControlName="shuffle_questions">Shuffle Questions</mat-checkbox>
            <div class="pt-10">
                <button (click)="this.addQuestion()" *ngIf="!editMode" color="primary" mat-raised-button>
                    <mat-icon>add</mat-icon>
                    Add Question
                </button>
            </div>
        </div>
        <mat-tab-group color="accent" formArrayName="questions">
            <mat-tab *ngFor="let testing of questions()?.controls; let questionIndex = index"
                     [label]="'Question ' + (questionIndex + 1)">
                <div [formGroupName]="questionIndex">
                    <div class="flex-col mb-10 pt-10">
                        <mat-form-field appearance="outline" class="w-100" color="accent">
                            <mat-label>Question</mat-label>
                            <textarea formControlName="text" matInput
                                      maxlength="400"
                                      required rows="3"></textarea>
                        </mat-form-field>

                        <mat-checkbox [disabled]="isScale" [hidden]="isScale"
                                      formControlName="multiple_choices">
                            Allow multiple choice
                        </mat-checkbox>

                        <mat-form-field
                                [hidden]="(isScale || !this.questions().at(questionIndex).value.multiple_choices) && !editMode"
                                appearance="outline" class="w-100"
                                color="accent">
                            <mat-label>Max number of responses</mat-label>
                            <input formControlName="max_responses" matInput min="2" type="number">
                            <mat-error *ngIf="this.questions().at(questionIndex).get('max_responses').hasError('min')">
                                Must allow at least 2 responses for multiple choice
                            </mat-error>
                        </mat-form-field>

                        <mat-checkbox #randomizeOptions [disabled]="isScale"
                                      [hidden]="isScale"
                                      formControlName="randomize_options">Randomise options ordering
                        </mat-checkbox>

                        <div *ngIf="!editMode" class="flex-row gap-10 flex-space-between">
                            <div class="flex-row gap-10" *ngIf="!isScale">
                                <div>
                                    <button (click)="addOption(questionIndex)" color="primary" mat-raised-button
                                            matTooltip="Add new option">
                                        <mat-icon>add</mat-icon>
                                        Add Option
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="questionIndex > 0">
                                <button (click)="this.removeQuestion(questionIndex)" class="w-content" color="warn"
                                        mat-raised-button>
                                    Remove Question
                                </button>
                            </div>
                        </div>
                        <ng-container *ngIf="questionIndex > 0">
                            <mat-form-field appearance="outline" class="w-100 mt-10" color="primary">
                                <mat-label>Display Conditions</mat-label>
                                <mat-select formControlName="display_condition_options_identifiers" multiple>
                                    <ng-container
                                            *ngFor="let question of questions()?.controls; let questionSelectIndex = index">
                                        <mat-optgroup *ngIf="questionSelectIndex < questionIndex"
                                                      [label]="'Question ' + (questionSelectIndex + 1)">
                                            <ng-container
                                                    *ngFor="let option of options(questionSelectIndex).controls; let optionIndex = index">
                                                <mat-option
                                                        [value]="option.value.identifier">{{ option.value.text || 'Option ' + (optionIndex + 1) }}
                                                </mat-option>
                                                <ng-container
                                                        *ngFor="let nestedOption of nestedOptions(questionSelectIndex, optionIndex).controls; let nestedOptionIndex = index">
                                                    <mat-option
                                                            [value]="nestedOption.value.identifier">Nested
                                                        Option: {{ nestedOption.value.text || (nestedOptionIndex + 1) }}
                                                    </mat-option>
                                                </ng-container>
                                            </ng-container>
                                        </mat-optgroup>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                            <small>Select options from the previous questions that must be selected to display this
                                question
                            </small>
                        </ng-container>
                    </div>
                    <div (cdkDropListDropped)="drop($event, questionIndex)" cdkDropList class="flex-col gap-15"
                         formArrayName="options">
                        <mat-card *ngFor="let option of options(questionIndex).controls; let optionIndex = index"
                                  cdkDrag class="pl-10">
                            <mat-card-title>
                                <h4>Option {{ optionIndex + 1 }}</h4>
                            </mat-card-title>
                            <mat-card-content>
                                <div class="d-flex gap-10">
                                    <div [formGroupName]="optionIndex" class="flex-1">
                                        <mat-form-field appearance="outline" class="w-100"
                                                        color="accent">
                                            <mat-label>Option text</mat-label>
                                            <input formControlName="text" matInput>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100"
                                                        color="accent">
                                            <mat-label>Option description</mat-label>
                                            <textarea formControlName="description"
                                                      matInput
                                                      maxlength="400" rows="2"></textarea>
                                        </mat-form-field>
                                        <div *ngIf="randomizeOptions.checked" class="flex-col">
                                            <mat-checkbox formControlName="fixed">Fixed</mat-checkbox>
                                            <small class="pl-10">The position of this option will not be
                                                randomized</small>
                                        </div>
                                        <div class="flex-col mb-10">
                                            <mat-checkbox formControlName="not_applicable">Not Applicable</mat-checkbox>
                                            <small class="pl-10">If a poll option is of type N/A (Not Applicable) then
                                                every other option is deselected for the poll when N/A is selected.
                                            </small>
                                        </div>
                                        <button (click)="addNestedOption(questionIndex, optionIndex, true)"
                                                *ngIf="nestedOptions(questionIndex, optionIndex).length <= 0 && !editMode"
                                                class="mb-10"
                                                color="primary"
                                                mat-raised-button>Add Nested
                                            Poll
                                        </button>
                                        <mat-accordion *ngIf="nestedOptions(questionIndex, optionIndex).length > 0"
                                                       class="mat-elevation-z5">
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>Nested Poll</mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <mat-form-field appearance="outline" class="w-100" color="accent">
                                                    <mat-label>Nested Poll Title</mat-label>
                                                    <textarea formControlName="nested_question_title" matInput
                                                              maxlength="400"
                                                              required rows="3"></textarea>
                                                </mat-form-field>
                                                <div class="w-100 d-flex flex-col">
                                                    <mat-checkbox formControlName="nested_multiple_choices">
                                                        Allow multiple choice
                                                    </mat-checkbox>
                                                    <mat-form-field
                                                            [hidden]="!getOption(questionIndex, optionIndex)?.value.nested_multiple_choices && !editMode"
                                                            appearance="outline" class="w-100"
                                                            color="accent">
                                                        <mat-label>Max number of responses</mat-label>
                                                        <input formControlName="max_nested_responses" matInput min="2"
                                                               type="number">
                                                        <mat-error
                                                                *ngIf="getOption(questionIndex, optionIndex).get('max_nested_responses').hasError('min')">
                                                            Must allow at least 2 responses for multiple choice
                                                        </mat-error>
                                                    </mat-form-field>

                                                    <mat-checkbox #randomizeNestedOptions
                                                                  formControlName="randomize_nested_options">
                                                        Randomize options ordering
                                                    </mat-checkbox>
                                                </div>
                                                <div *ngIf="!editMode"
                                                     class="flex-row gap-10 flex-space-between my-10 pb-10">
                                                    <div class="flex-row gap-10">
                                                        <div>
                                                            <button (click)="addNestedOption(questionIndex, optionIndex)"
                                                                    color="primary"
                                                                    mat-raised-button
                                                                    matTooltip="Add new option">
                                                                <mat-icon>add</mat-icon>
                                                                Add Nested Option
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button (click)="this.removeNestedPoll(questionIndex, optionIndex)"
                                                                class="w-content" color="warn"
                                                                mat-raised-button>
                                                            Remove Nested Poll
                                                        </button>
                                                    </div>
                                                </div>
                                                <div (cdkDropListDropped)="dropNested($event, questionIndex, optionIndex)"
                                                     cdkDropList class="flex-col gap-15"
                                                     formArrayName="nested_options">
                                                    <mat-card
                                                            *ngFor="let nestedOption of nestedOptions(questionIndex, optionIndex).controls; let nestedOptionIndex = index"
                                                            cdkDrag class="pl-10 mat-elevation-z10">
                                                        <mat-card-title>
                                                            <h4>Option {{ nestedOptionIndex + 1 }}</h4>
                                                        </mat-card-title>
                                                        <mat-card-content>
                                                            <div class="d-flex gap-10">
                                                                <div [formGroupName]="nestedOptionIndex" class="flex-1">
                                                                    <mat-form-field appearance="outline" class="w-100"
                                                                                    color="accent">
                                                                        <mat-label>Option text</mat-label>
                                                                        <input formControlName="text" matInput>
                                                                    </mat-form-field>
                                                                    <mat-form-field appearance="outline" class="w-100"
                                                                                    color="accent">
                                                                        <mat-label>Option description</mat-label>
                                                                        <textarea formControlName="description"
                                                                                  matInput
                                                                                  maxlength="400" rows="2"></textarea>
                                                                    </mat-form-field>
                                                                    <div class="flex-col">
                                                                        <mat-checkbox formControlName="not_applicable">
                                                                            Not Applicable
                                                                        </mat-checkbox>
                                                                        <small class="pl-10">If a poll option is of type
                                                                            N/A (Not Applicable) then
                                                                            every other option is deselected for the
                                                                            poll when N/A is selected.
                                                                        </small>
                                                                    </div>
                                                                    <div *ngIf="randomizeNestedOptions.checked"
                                                                         class="flex-col">
                                                                        <mat-checkbox formControlName="fixed">Fixed
                                                                        </mat-checkbox>
                                                                        <small class="pl-10">The position of this option
                                                                            will not be randomized</small>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-col flex-space-evenly" matSuffix>
                                                                    <button (click)="removeNestedOption(questionIndex, optionIndex, nestedOptionIndex)"
                                                                            *ngIf="nestedOptions(questionIndex, optionIndex).length >= 3 && !editMode"
                                                                            class="icon"
                                                                            mat-icon-button
                                                                            matTooltip="Remove this option">
                                                                        <mat-icon>remove</mat-icon>
                                                                    </button>

                                                                    <button *ngIf="nestedOptions(questionIndex, optionIndex).length > 1 && !editMode"
                                                                            cdkDragHandle class="icon"
                                                                            mat-icon-button
                                                                            matTooltip="Drag Option To Change Order">
                                                                        <mat-icon>drag_indicator</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </mat-card-content>
                                                    </mat-card>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion>
                                    </div>
                                    <div class="flex-col flex-space-evenly" matSuffix>
                                        <button (click)="removeOption(questionIndex, optionIndex)"
                                                *ngIf="options(questionIndex).length >= 3 && !editMode"
                                                class="icon"
                                                mat-icon-button
                                                matTooltip="Remove This Option">
                                            <mat-icon>remove</mat-icon>
                                        </button>

                                        <button *ngIf="options(questionIndex).length > 1 && !editMode" cdkDragHandle
                                                class="icon"
                                                mat-icon-button
                                                matTooltip="Drag Option To Change Order">
                                            <mat-icon>drag_indicator</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </form>
</div>
